/* feature-20260615-tshirts（楽天GOLD feature/2026/*-tshirts/ からの移植）
   楽天版のページ内スクリプトをそのまま持ってきたもの。
   共通部分（スムーススクロール／フェードイン／ページトップ）は lp-feature.js に分けてある。
   jQuery はテンプレート側で読み込んでいる。 */
/* スクロールに応じてアクティブタブを自動切り替え */
    (function () {
      const nav     = document.getElementById('stickyNav');
      const btns    = nav.querySelectorAll('.snav-btn');
      /* ▼ 各セクションのIDと対応するボタンを紐付け */
      const targets = ['graphic', 'basic', 'design', 'utility'];

      function setActive(id) {
        btns.forEach(btn => {
          btn.classList.toggle('active', btn.getAttribute('href') === '#' + id);
        });
      }

      const observer = new IntersectionObserver(entries => {
        entries.forEach(el => {
          if (el.isIntersecting) setActive(el.target.id);
        });
      }, {
        rootMargin: '-40% 0px -55% 0px', /* 画面中央付近で切り替わる */
        threshold: 0
      });

      targets.forEach(id => {
        const el = document.getElementById(id);
        if (el) observer.observe(el);
      });

      /* スムーズスクロール（sticky navの高さ分オフセット） */
      btns.forEach(btn => {
        btn.addEventListener('click', e => {
          e.preventDefault();
          const id = btn.getAttribute('href').slice(1);
          const target = document.getElementById(id);
          if (!target) return;
          const offset = nav.offsetHeight + 8;
          const top = target.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top, behavior: 'smooth' });
        });
      });
    })();
